"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const Loader = (props) => {
    const { scale = 1, color = "red" } = props;
    return (react_1.default.createElement("div", { style: { height: 32 * scale, width: 32 * scale, borderWidth: 1 * scale }, className: `c-loader c-loader__${color}` }));
};
exports.Loader = Loader;
